<div class="wrapper">
  <div [ngClass]="{'top-box':true}">
    <h3 [ngClass]="{'box-label':true}">{{data.displayName}}</h3>
    <ng-container *ngIf="reviewMode || selectMode">
      <div
        [ngClass]="{'description':true, 'border-b':reviewMode}"
        [innerHTML]="data.shortDescription || 'Get Unlimited data plan with ultra-fast premium data'">
      </div>
    </ng-container>
    <ng-container *ngIf="manageMode || selectMode">
      <div class="rate-box border-t">
        <span class="price">${{data.price.regularPrice}} per line per month</span>
        <span class="price-details">Before taxes and fees.</span>
        <span class="price-details">Plus one time activation fee of $35</span>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="selectMode">
    <div class="accordion" *ngFor="let dropDown of dropdownsData">
      <app-simple-accordion
        [description]="dropDown.description"
        [isOpen]="true"
        [title]="dropDown.title">
      </app-simple-accordion>
    </div>
    <!-- <div class="select-description" [innerHTML]="data.description"></div>     -->
    <div class="select-description">
       <!-- This HTML would come from API in the future-->
      <div style="display: flex; flex-direction:column">
        <a style="margin-bottom: 16px; display:block; color:#000;font-size: 13px;font-weight: 400;line-height: 16px;text-decoration-line: underline;" href="https://www.verizon.com/support/important-plan-information/" target="_blank">Important plan information</a>
        <a style="margin-bottom: 16px; display:block; color:#000;font-size: 13px;font-weight: 400;line-height: 16px;text-decoration-line: underline;" href="https://www.verizon.com/support/broadband-services/" target="_blank">Important broadband information</a>
        <p style="margin: 0"> Need support? You can reach us at <a style="text-decoration: none; color: #0077B4; font-weight: bold;" href="tel:8009220204">800.922.0204</a></p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="selectMode">
    <div class="box-button">
      <app-main-button
        (onClick)="onSelectPlanMethod()"
        [buttonWidth]="'92vw'"
        [disabled]="disableButtons"
        [buttonText]="disableButtons ? 'Current plan': 'Select plan'">
      </app-main-button>
    </div>
  </ng-container>
  <ng-container *ngIf="manageMode">
    <div class="manage-buttons-box">
      <app-main-button
        (onClick)="onChangePlanMethod()"
        [disabled]="disableButtons"
        [buttonWidth]="'170px'"
        [buttonHeight]="'44px'"
        [backgroundColor]="'#FFFFFF'"
        [textColor]="'#000000'"
        [fontSize]="'16px'"
        [border]="'1px solid #000000'"
        [buttonText]="'Change plan'">
      </app-main-button>
      <app-main-button
        (onClick)="onCancelPlanMethod()"
        [disabled]="disableButtons"
        [buttonWidth]="'170px'"
        [buttonHeight]="'44px'"
        [backgroundColor]="'#FFFFFF'"
        [textColor]="'#000000'"
        [fontSize]="'16px'"
        [border]="'1px solid #000000'"
        [buttonText]="'Cancel plan'">
      </app-main-button>
    </div>
  </ng-container>
  <ng-container *ngIf="reviewMode">
    <div class="rate-box-review-mode">
      <span class="price">${{data.price}}</span>
      <div class="price-description">
        <span class="price-details">more per month</span>
        <span class="price-details">Before taxes and fees.</span>
      </div>
    </div>
  </ng-container>
</div>
